import { createTheme } from '@mui/material/styles'

const caColour = '#6ac498'
// See https://mui.com/x/react-date-pickers/custom-components/ for theming options
export default createTheme({
  components: {
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: caColour,
            '&:hover': { backgroundColor: caColour }
          }
        },
        today: { color: caColour, borderColor: caColour }
      }
    },
    MuiDatePickerToolbar: {
      styleOverrides: { root: { backgroundColor: caColour } }
    },
    MuiInputBase: {
      styleOverrides: {
        root: { cursor: 'pointer' },
        input: { cursor: 'pointer', userSelect: 'none' }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          '&:hover:not(.Mui-disabled):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline': {
            borderColor: caColour
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: caColour }
        },
        notchedOutline: { borderColor: '#6288A5' }
      }
    },
    MuiFormLabel: {
      styleOverrides: { root: { '&.Mui-focused': { color: caColour } } }
    }
  }
})
